import { render } from "./IReportsList.vue?vue&type=template&id=4aeae4a1"
import script from "./IReportsList.vue?vue&type=script&lang=js"
export * from "./IReportsList.vue?vue&type=script&lang=js"

import "./IReportsList.vue?vue&type=style&index=0&id=4aeae4a1&lang=sass"

import exportComponent from "C:\\Riman\\Web\\Alex\\newmapper\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__